import { flow, types } from 'mobx-state-tree'
import { GetOccupationData } from '../../../network/DomesticMoneyTransfer/GetOccupationData'
import { addNewBeneficiaryApi } from '../../../network/DomesticMoneyTransfer/addNewBeneficiaryApi'
import { deleteBeneApi } from '../../../network/DomesticMoneyTransfer/deleteBeneficiary'
import { doesBeneficiaryWithSameAccountExist } from '../../../network/DomesticMoneyTransfer/doesBeneficiaryWithSameAccountExist'
import { getAllBanks } from '../../../network/DomesticMoneyTransfer/getAllBanks'
import { getAllBranches } from '../../../network/DomesticMoneyTransfer/getAllBranches'
import { getAllCities } from '../../../network/DomesticMoneyTransfer/getAllCities'
import { getBankIfsc } from '../../../network/DomesticMoneyTransfer/getBankIfsc'
import { getBankIfscList } from '../../../network/DomesticMoneyTransfer/getBankIfscList'
import { getBeneficiaryList } from '../../../network/DomesticMoneyTransfer/getBeneficiaryListApi'
import { getBeniDmtLimitApi } from '../../../network/DomesticMoneyTransfer/getBeniLimitApi'
import { getIfscCode } from '../../../network/DomesticMoneyTransfer/getIfscCode'
import { validateBeneficiaryCharges } from '../../../network/DomesticMoneyTransfer/validateBeneficiaryCharges'
import { validateBeneficiaryWithAmountDeductionApi } from '../../../network/DomesticMoneyTransfer/validateBeneficiaryWithAmountDeductionApi'
import { validateIfscCodeApi } from '../../../network/DomesticMoneyTransfer/validateIfscCodeApi'
import { parseJsonString } from '../../../util/utill'
import { RootStore } from '../../store'
import { checkValidateBenifStatusApi } from './../../../network/DomesticMoneyTransfer/checkValidateBenifStatusApi'
import { delay } from './../../../util/utill'

export const BENE_NOT_EXIST_CODE = '40009'
export const BENE_EXIST_CODE = '40008'
const MAX_ADD_BEFIF_STATUS_RETRY = 15

const Beneficiary = types.model('Beneficiary', {
  accountId: types.optional(types.maybeNull(types.string), ''),
  accountType: types.optional(types.maybeNull(types.string), ''),
  beneAccountHolderName: types.optional(types.maybeNull(types.string), ''),
  beneAccountNumber: types.optional(types.maybeNull(types.string), ''),
  beneDescription: types.optional(types.maybeNull(types.string), ''),
  beneEmailId: types.optional(types.maybeNull(types.string), ''),
  beneId: types.optional(types.maybeNull(types.string), ''),
  beneIfscCode: types.optional(types.maybeNull(types.string), ''),
  beneMobileCountryCode: types.optional(types.maybeNull(types.integer), 0),
  beneMobileNumber: types.optional(types.maybeNull(types.integer), 0),
  beneNickName: types.optional(types.maybeNull(types.string), ''),
  beneStatus: types.optional(types.maybeNull(types.string), ''),
  beneType: types.optional(types.maybeNull(types.string), ''),
  createdAt: types.optional(types.maybeNull(types.integer), 0),
  createdBy: types.optional(types.maybeNull(types.string), ''),
  createdFromChannel: types.optional(types.maybeNull(types.string), ''),
  remitterId: types.optional(types.maybeNull(types.string), ''),
  productId: types.optional(types.maybeNull(types.string), ''),
  statusReasonCode: types.optional(types.maybeNull(types.string), ''),
  updatedAt: types.optional(types.maybeNull(types.integer), 0),
  updatedBy: types.optional(types.maybeNull(types.string), ''),
  updatedFromChannel: types.optional(types.maybeNull(types.string), ''),
})

const IFSC = types.model('IFSC', {
  bankCity: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  branchName: types.optional(types.string, ''),
  ifscCode: types.optional(types.string, ''),
})

const OccupationList = types.model('OccupationList', {
  id: types.optional(types.string, ''),
  text: types.optional(types.string, ''),
})

const ValidateBeneficiaryData = types.model('OccupationList', {
  id: types.optional(types.string, ''),
  code: types.optional(types.string, ''),
  key: types.optional(types.string, ''),
  value: types.optional(types.string, ''), //We need to parse this value
  category: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  createdBy: types.optional(types.string, ''),
  updatedBy: types.optional(types.string, ''),
})

const BeneficiaryDetails = types
  .model('BeneficiaryDetails', {
    amount: types.optional(types.string, ''),
    accountHolderName: types.optional(types.maybeNull(types.string), null),
    beneficiaryFirstName: types.optional(types.string, ''),
    beneficiaryLastName: types.optional(types.string, ''),
    beneficiaryAccountNumber: types.optional(types.string, ''),
    bankNameArray: types.optional(types.array(types.string), []),
    cityNameArray: types.optional(types.array(types.string), []),
    branchNameArray: types.optional(types.array(types.string), []),
    ifscCode: types.optional(types.string, ''),
    applicableBankCharges: types.optional(types.string, ''),
    isSaveBeneficiaryClicked: types.optional(types.boolean, false),
    convenienceFees: types.optional(types.string, ''),
    beneficiaryList: types.optional(types.array(Beneficiary), []),
    ifscMetaData: types.optional(IFSC, {}),
    beneficiaryId: types.optional(types.string, ''),
    beneficiaryBankName: types.optional(types.string, ''),
    occupationMasterList: types.optional(types.array(OccupationList), []),
    totalTaxesOfConvenience: types.optional(types.number, 0),
    grossAmountOfValidation: types.optional(types.number, 0),
    //isBeneficiaryValidated: types.optional(types.boolean, false),
    validateBeneficiaryStatus: types.optional(types.string, ''),
    beneNameFromApi: types.optional(types.string, ''),
    beneficiaryValidationReachedCounter: types.optional(types.boolean, false),
    isBeneficiaryAdded: types.optional(types.boolean, false),
    doesBeneWithSameAccountExist: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateBeneficiaryData(data: any) {
      console.log('data', data)
      self.beneficiaryFirstName = data?.beneficiaryFirstName
      self.beneficiaryLastName = data?.beneficiaryLastName
      self.beneficiaryAccountNumber = data?.beneficiaryAccountNumber
      self.ifscCode = data?.ifscCode
      self.beneficiaryBankName = data?.beneficiaryBankName
      // self.isSaveBeneficiaryClicked = data?.isSaveBeneficiaryClicked === 'true'
      self.beneficiaryId = data?.beneficiaryId
    },
    updateAccountHolderName(name: any) {
      self.accountHolderName = name
    },
    resetBeneficiaryList() {
      self.beneficiaryList = [] as any
    },
    validateBeneficiaryWithAmountDeduction: flow(function* validateBeneficiaryWithAmountDeduction(data: any) {
      try {
        const postData: any = {
          //@ts-ignore
          netAmount: self.getValidateBeneficiaryCharge(),
          grossAmount: self.grossAmountOfValidation,
          charges: RootStore.transactionDetails.feeDetails?.[0]?.fee?.feeTax,
          remittanceUserId: RootStore.customerDetails.remittanceUserId,
          mobile: RootStore.customerDetails.mobile,
          grossAmountOfValidation: self.grossAmountOfValidation,
          beneficiaryAccountNumber: data.accountNumber,
          ifscCode: data.ifscCode.ifscCode,
          bankName: data.ifscCode.bankName,
          beneficiaryFirstName: data.firstName,
          beneficiaryLastName: data.lastName,
        }
        const response = yield validateBeneficiaryWithAmountDeductionApi(
          RootStore.moneyTransferSession.getTokens,
          postData,
        )
        return {
          ...response,
          beneficiaryAccountNumber: data.accountNumber,
          ifscCode: data.ifscCode.ifscCode,
          bankName: data.ifscCode.bankName,
          beneficiaryFirstName: data.firstName,
          beneficiaryLastName: data.lastName,
        }
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    checkStatusValidateBenif: flow(function* checkStatusValidateBenif(validateBefifResp: any) {
      try {
        const postData: any = {
          id: validateBefifResp?.responseData?.transactionId,
          originalId: validateBefifResp?.responseData?.originalId,
          idempotentKey: validateBefifResp?.responseData?.idempotentKey,
          referenceNumber: validateBefifResp?.responseData?.rrn,
          //@ts-ignore
          netAmount: self.getValidateBeneficiaryCharge(),
          grossAmount: self.grossAmountOfValidation,
          charges: RootStore.transactionDetails.feeDetails?.[0]?.fee?.feeTax,
          remittanceUserId: RootStore.customerDetails.remittanceUserId,
          mobile: RootStore.customerDetails.mobile,
          grossAmountOfValidation: self.grossAmountOfValidation,
          beneficiaryAccountNumber: validateBefifResp.beneficiaryAccountNumber,
          ifscCode: validateBefifResp.ifscCode,
          bankName: validateBefifResp.bankName,
          beneficiaryFirstName: validateBefifResp.beneficiaryFirstName,
          beneficiaryLastName: validateBefifResp.beneficiaryLastName,
        }

        const response = yield checkValidateBenifStatusApi(RootStore.moneyTransferSession.getTokens, postData)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    poolValidateBenifStatus: flow(function* poolValidateBenifStatus(
      validateBefifResp: any,
      noOfRetry: any,
      getAbortController: any,
    ) {
      try {
        console.log('htag poolValidateBenifStatus', validateBefifResp)
        const { abortRecursive } = getAbortController()
        if (abortRecursive) {
          throw { message: 'Operation Aborted.' }
        }
        const response = yield (self as any).checkStatusValidateBenif(validateBefifResp)
        console.log('htag checkStatusValidateBenif', response)
        if (response?.responseCode !== '00' && noOfRetry < MAX_ADD_BEFIF_STATUS_RETRY) {
          console.log('htag checkStatusValidateBenif', noOfRetry)
          yield delay(2000)
          return yield self.poolValidateBenifStatus(validateBefifResp, noOfRetry + 1, getAbortController)
        }
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    addNewBeneficiary: flow(function* addNewBeneficiary(beneficiaryData: any) {
      try {
        const response = yield addNewBeneficiaryApi(RootStore.moneyTransferSession.getTokens, beneficiaryData)
        self.beneficiaryId = response?.beneId
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getBeneficiaryListApi: flow(function* getBeneficiaryListApi(remittanceUserId) {
      try {
        const response = yield getBeneficiaryList(RootStore.moneyTransferSession.getTokens, remittanceUserId)
        if (response?.error) {
          self.beneficiaryList = [] as any
          // RootStore.customerDetails.clearNewRemittanceUserId()
          // self.newRemittanceUserId
          return
        } else {
          self.beneficiaryList = response
        }
        console.log(response, "beneficiarylistdata::")
        return response
      } catch (err) {
        self.beneficiaryList = [] as any
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getDmtLimit: flow(function* getDmtLimit(remitanceUserId: string) {
      try {
        const response = yield getBeniDmtLimitApi(RootStore.moneyTransferSession.getTokens);
        return response.data;
      } catch (err) {
        RootStore.message.handleError(err)
        throw err;
      }
    }),
    deleteBeneficiary: flow(function* deleteBeneficiary(payload: {
      beneId: string,
      authCode: string,
      remittanceUserId: string,
      mobile: string
    }) {
      try {
        const tokens = RootStore.moneyTransferSession.getTokens;
        const response = yield deleteBeneApi(tokens, payload);
        yield (self as any).getBeneficiaryListApi(payload.remittanceUserId);
        return response;
      } catch (err) {
        RootStore.message.handleError(err);
        throw err;
      }
    }),
    //Get the list of banks
    getBankNamesList: flow(function* getBankNamesList() {
      try {
        const response = yield getAllBanks(RootStore.moneyTransferSession.getTokens)
        if (response?.length > 0) {
          const banks: any = []
          response?.map((item: any) => {
            if (item?.bankName !== null) {
              banks.push(item?.bankName)
              self.bankNameArray = banks
            }
          })
        }
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    //Get the list of cities
    getCityList: flow(function* getCityList(bankName: string) {
      try {
        const response = yield getAllCities(RootStore.moneyTransferSession.getTokens, bankName)
        if (response?.length > 0) {
          self.cityNameArray = [] as any
          response?.map((item: any) => {
            if (item?.bankCity !== null) {
              self.cityNameArray.push(item?.bankCity)
            }
          })
        }

        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    //Get the list of branches
    getBranchList: flow(function* getBranchList(bankName: string, cityName: string) {
      try {
        const response = yield getAllBranches(RootStore.moneyTransferSession.getTokens, bankName, cityName)
        if (response?.length > 0) {
          self.branchNameArray = [] as any
          response?.map((item: any) => {
            if (item?.branchName !== null) {
              self.branchNameArray.push(item?.branchName)
            }
            return item
          })
        }
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    getIFSCcode: flow(function* getIFSCcode(bankName: string, cityName: string, branchName: string) {
      try {
        const response = yield getIfscCode(RootStore.moneyTransferSession.getTokens, bankName, cityName, branchName)
        self.ifscMetaData = response[0]
        self.ifscCode = response[0]?.ifscCode
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    validateIfscCode: flow(function* validateIfscCode(ifscCode: string) {
      try {
        const response = yield validateIfscCodeApi(RootStore.moneyTransferSession.getTokens, ifscCode)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchbankIfsc: flow(function* fetchbankIfsc(bankName: string, ifscCode: string) {
      try {
        const response = yield getBankIfsc(bankName, ifscCode, RootStore.moneyTransferSession.getTokens)
        return response
      } catch (err) {
        if (err?.errorCode !== '50100') {
          RootStore.message.handleError(err)
        }
        throw err
      }
    }),

    validateBeneficiaryChargeDetails: flow(function* validateBeneficiaryChargeDetails() {
      try {
        const response = yield validateBeneficiaryCharges(RootStore.moneyTransferSession.getTokens)
        //self.validateBeneficiaryAmountData = response?.data?.[0]
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    getAddBenifCharges: flow(function* getAddBenifCharges() {
      try {
        //@ts-ignore
        const validateBeneficiaryResponse = yield self.validateBeneficiaryChargeDetails(
          RootStore.moneyTransferSession.getTokens,
        )
        const validateBeneficiaryAmountData = validateBeneficiaryResponse?.data?.[0]
        const myJSONString = parseJsonString(validateBeneficiaryAmountData.value)
        const parsedData = JSON.parse(myJSONString)
        const grossAmount = parsedData?.amount?.grossAmount
        self.grossAmountOfValidation = grossAmount
        const response = yield RootStore.transactionDetails.getConvenienceFee(grossAmount, ValidateBeneficiaryData)
        const destructuredAmount = JSON.parse(JSON.stringify(RootStore.transactionDetails.feeDetails[0]?.fee?.feeTax))
        const totalAmount =
          destructuredAmount?.cgst +
          destructuredAmount?.igst +
          destructuredAmount?.sgst +
          destructuredAmount?.tds +
          destructuredAmount?.ugst
        //@ts-ignore
        self.totalTaxes(totalAmount ?? 0)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    //validateBenificiaryAsync: flow(function* validateBenificiaryAsync(validateBefifResp: any) {

    GetOccupationDataApi: flow(function* GetOccupationDataApi() {
      try {
        const response = yield GetOccupationData(RootStore.moneyTransferSession.getTokens)
        if (response?.occupationMasterList?.length > 0) {
          const arrayNew = [] as any
          response?.occupationMasterList?.map((item: any) => {
            if (item?.description !== null) {
              arrayNew.push({ id: item?.lov, text: item?.description })
            }
          })
          self.occupationMasterList = arrayNew
        }
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    fetchBankIfscList: flow(function* fetchBankIfscList() {
      try {
        const response = yield getBankIfscList(RootStore.moneyTransferSession.getTokens)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),

    doesBeneficiaryAlreadyExist: flow(function* doesBeneficiaryAlreadyExist(
      remitterId: string,
      beneAccountNumber: string,
      beneIfscCode: string,
    ) {
      try {
        const response = yield doesBeneficiaryWithSameAccountExist(
          RootStore.moneyTransferSession.getTokens,
          remitterId,
          beneAccountNumber,
          beneIfscCode,
        )
        if (response?.code !== BENE_NOT_EXIST_CODE) {
          const ERROR = { message: response?.message, code: response?.code }
          RootStore.message.handleError(ERROR)
          throw ERROR
        }
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    totalTaxes(data: number) {
      self.totalTaxesOfConvenience = data
    },
    updateGrossAmountOfValidation(data: number) {
      self.grossAmountOfValidation = data
    },
    updateIsBeneficiaryValidated(val: boolean) {
      self.isBeneficiaryValidated = val
    },
    toggleBeneficiaryValidationCounterLimit(val: boolean) {
      self.beneficiaryValidationReachedCounter = val
    },
    updateIfscCode(val: string) {
      self.ifscCode = val
    },
    resetIfscMetaData() {
      self.ifscMetaData.bankCity = ''
      self.ifscMetaData.bankName = ''
      self.ifscMetaData.branchName = ''
      self.ifscMetaData.ifscCode = ''
    },
    toggleIsBeneficiaryAdded(val: boolean) {
      self.isBeneficiaryAdded = val
    },
  }))
  .views((self) => ({
    getBeneficiaryListData() {
      return self.beneficiaryList
    },
    getValidateBeneficiaryCharge() {
      return self.grossAmountOfValidation + self.totalTaxesOfConvenience
    },
    getBeneficiaryDetails() {
      return {
        beneficiaryFirstName: self.beneficiaryFirstName,
        beneficiaryLastName: self.beneficiaryLastName,
        beneficiaryAccountNumber: self.beneficiaryAccountNumber,
        accountHolderName: self.accountHolderName,
        ifscCode: self.ifscCode,
        beneficiaryId: self.beneficiaryId,
        bankName: self.beneficiaryBankName,
      }
    },
  }))

const BeneficiaryDetailsData = BeneficiaryDetails.create({})

export { BeneficiaryDetails, BeneficiaryDetailsData }

interface GetAddBenifChargesProps {
  accountNumber: string
  ifscCode: {
    ifscCode: string
    bankName: string
  }
  firstName: string
  lastName: string
}
